var define = function () {
    function pageBodyLoad() {
        checkUserStatus();
    }

    function getFolderId() {
        let folderId = coreFunctions.getQueryVariable("folder-id");
        if (folderId && !isNaN(folderId)) {
            folderId = parseInt(folderId);
        } else {
            folderId = null;
        }
        return folderId;
    }

    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            getUserStatusLoad(JSON.parse(response));
        }

        const checkUserStatusError = function () {
            var response = {
                "logged_in": false,
                "message": "Could not check user status"
            }
            getUserStatusLoad(response);
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    // Limit trial users functionality to 60 companies per list
    function restrictFunctionalityForTrialUser() {
        var listSizeOptions = listSizeSelect.querySelectorAll("option");
        for (var i = 0; i < listSizeOptions.length; i++) {
            // 60 companies only allowed
            if (listSizeOptions[i].value == "60") {
                listSizeOptions[i].selected = true;
            } else {
                // Update text for each option
                listSizeOptions[i].disabled = true
                var currentEntry = listSizeOptions[i].innerHTML;
                listSizeOptions[i].innerHTML = currentEntry.replace("(default)", "") + " (Full users only)";
            }
        }
    }

    function getUserStatusLoad(response) {
        // Valid user
        if (response.logged_in == true) {
            coreFunctions.userguidingSetup(response);
            //addTrainingSetProgressElements();
            // Trial user, restrict options
            if (response.user_details.trial_user == true) {
                restrictFunctionalityForTrialUser();
            };
            main.classList.remove("mainHidden");
            mlList.checkForStoredListDetails();
            mlList.listKeywords.configureKeywordInputElements();
        }
        //
        else {
            requireLogin();
        }
    }

    class ML_List {
        constructor(folderId) {
            this.name = `My list ${moment().format("D-MMM-YYYY")}`;
            this.returnCount = null;
            this.trainingSet = new TrainingSet();
            this.listKeywords = new ListKeywords();
            this.folderId = folderId;
        }

        processListDetails() {
            this.name = (document.getElementById("inputListNameElement").value.length > 0) ? document.getElementById("inputListNameElement").value : this.name;
            this.returnCount = Number(document.getElementById("listSizeSelect").value);
            document.getElementById("defineListTitle").innerHTML = this.name;
            document.getElementById("listSectionDetails").classList.add("listSectionHidden");
            document.getElementById("listTrainingSet").classList.remove("listSectionHidden");
            window.scrollTo(0, 0);
            return this;
        }

        backToListDetails() {
            document.getElementById("listTrainingSet").classList.add("listSectionHidden");
            document.getElementById("listSectionDetails").classList.remove("listSectionHidden");
            window.scrollTo(0, 0);
            return this;
        }

        storeCurrentListDetails() {
            let currentListCode = coreFunctions.getRandomString(15);
            const currentListDetails = {
                listCode: currentListCode,
                name: this.name,
                returnCount: this.returnCount,
                trainingSet: this.trainingSet.formatTrainingSetForStorage()
            }
            localStorage.setItem("currentlistdetails", JSON.stringify(currentListDetails));
            window.history.replaceState('trainingsetcode', 'trainingsetcodeedit', `?newlistcode=${currentListCode}`);
            return this;
        }

        checkForStoredListDetails() {
            let storedListCode, storedListDetails;
            if ((storedListCode = coreFunctions.getQueryVariable("newlistcode")) && localStorage.getItem("currentlistdetails")) {
                storedListDetails = JSON.parse(localStorage.getItem("currentlistdetails"));
                if (storedListDetails.listCode == storedListCode) {
                    this.presetListDetails(storedListDetails);
                }
            }
        }

        presetListDetails(storedListDetails) {
            const mlListObject = this;
            document.getElementById("inputListNameElement").value = storedListDetails.name;
            document.getElementById("listSizeSelect").value = storedListDetails.returnCount;
            storedListDetails.trainingSet.forEach(company => {
                mlListObject.trainingSet.newTrainingSetCompany(company.trainingSetType, company.companyNumber, company.companyName, company.companyURL, company.companyPostcode, JSON.stringify(company.keywords)).addTrainingSetElementToList();
            });
            this.processListDetails();
            mlListObject.trainingSet.updateTrainingSetBuildProgress();
            return this;
        }

        saveNewCompanyList() {
            let input, method, url;
            const mlListObject = this;

            input = mlListObject.getNewListParameters();
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=prepare_new_list`;

            const saveNewCompanyListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                mlListObject.saveNewCompanyListLoad(response);
            }

            const saveNewCompanyListError = function () {
                const response = {
                    "status": "error",
                    "title": "Error",
                    "message": "Could not save company list."
                }
                mlListObject.saveNewCompanyListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, saveNewCompanyListSuccess, saveNewCompanyListError, JSON.stringify(input));
        }

        saveNewCompanyListLoad(response) {
            if (response.status == "success") {
                window.location.href = `${urlPath}/ml_list?list_id=${response.list_id}`;
            } else {
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        getNewListParameters() {
            const savedListParameters = {
                title: this.name,
                returnCount: this.returnCount,
                trainingCompanies: this.trainingSet.formatTrainingSetForSaving(),
                myWords: this.trainingSet.processTrainingSetKeywords(),
                folderId: this.folderId
            }
            return savedListParameters;
        }

    }

    class TrainingSet {
        constructor() {
            this.include = [];
            this.exclude = [];
            this.minimumCompaniesInTrainingSet = 5;
        }

        // Format URLs for company search input
        formatCompanySearchInput(element) {
            element.value = element.value.replace(/^http(s)?:\/\//, "").replace(/\/$/, "");
            return this;
        }

        formatTrainingSetForStorage() {
            const trainingSet = [];
            this.include.forEach(company => trainingSet.push({
                companyNumber: company.companyNumber,
                companyName: company.companyName,
                companyURL: company.companyURL,
                companyPostcode: company.companyPostcode,
                trainingSetType: company.trainingSetType,
                keywords: company.keywords
            }));
            return trainingSet;
        }

        formatTrainingSetForSaving() {
            const processedTrainingSet = {
                include: [],
                exclude: []
            }
            this.include.forEach(company => processedTrainingSet.include.push({
                companynumber: company.companyNumber,
                companyname: company.companyName,
                companyurl: company.companyURL
            }));
            this.exclude.forEach(company => processedTrainingSet.exclude.push({
                companynumber: company.companyNumber,
                companyname: company.companyName,
                companyurl: company.companyURL
            }));
            return processedTrainingSet;
        }

        processTrainingSetKeywords() {
            return [...new Set(this.include.map(company => company.keywords).flat())];
        }

        // Find if a URL exists in any training set type
        getTrainingSetContainingCompanyUrl(companyURL) {
            let trainingSetContainingCompanyUrl;
            let match = this.include.concat(this.exclude).find(element => element.companyURL == companyURL);
            if (match) {
                trainingSetContainingCompanyUrl = match.trainingSetType;
            }
            return trainingSetContainingCompanyUrl;
        }

        companyUrlExistsInTrainingSet(companyURL) {
            return this.getTrainingSetContainingCompanyUrl(companyURL) != undefined;
        }

        companyNumberOrNameSearch(form) {
            let input, method, url;
            const listObject = this;
            this.showSearchSpinner();
            document.getElementById("companyNumberOrNameSearchButton").disabled = true;
            document.getElementById("companyInputMain").classList.add("searchInProgress");

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=company_name_search`;

            const companySearchSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listObject.companyNumberOrNameSearchLoad(response);
            }

            const companySearchError = function () {
                const response = {
                    status: "error",
                    title: "Search error",
                    message: "Sorry, search could not be processed."
                }
                listObject.companyNumberOrNameSearchLoad(response);
            }

            coreFunctions.xhrHelper(method, url, companySearchSuccess, companySearchError, input);

        }

        companyNumberOrNameSearchLoad(response) {
            this.hideSearchSpinner();
            document.getElementById("companyNumberOrNameSearchButton").disabled = false;
            document.getElementById("companyInputMain").classList.remove("searchInProgress");
            if (response.status == "success") {
                coreFunctions.checkForDebugMessages(response);
                this.resetSearchResultsElement().processSearchResults(response.results, response.trainingSetType, []);
            } else {
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        companySearchOnInput() {
            let inputErrors = document.querySelectorAll(".findButton_error:not(.hidden)");
            for (var i = 0; i < inputErrors.length; i++) {
                inputErrors[i].classList.add("hidden");
            }
        }

        resetSearchResultsElement() {
            let searchResultsElement = document.querySelector("#searchResultsHolder .trainingSetListHolder");
            while (searchResultsElement.firstChild) {
                searchResultsElement.removeChild(searchResultsElement.firstChild);
            }
            return this;
        }

        processSearchResults(companies, trainingSetType, activeKeywords) {
            const trainingSetObject = this;
            document.getElementById("searchResultsHolder").classList.remove("hidden");
            companies = companies.filter(element => element.CompanyStatus == "Active"); // Only allow active companies to be added based on CompanyStatus field. Smart search results do not hav
            if (companies.length > 0) {
                document.getElementById("addAllCompaniesButton").classList.remove("hidden");
                companies.forEach((company) => {
                    trainingSetObject.addCompanyElementToSearchResults(company.CompanyNumber, company.CompanyName, coreFunctions.formatUrl(company.CompanyURL), company.CompanyPostcode, trainingSetType, activeKeywords);
                });
            } else {
                this.noCompaniesMatchSearchQuery();
            }
            return this;
        }

        noCompaniesMatchSearchQuery() {
            let searchResultsElement = document.querySelector("#searchResultsHolder .trainingSetListHolder");
            searchResultsElement.innerHTML = `<span class='noCompaniesFound'><img src='${urlPath}/images/warning.svg'>No companies found</span>`;
            document.getElementById("addAllCompaniesButton").classList.add("hidden");
            return this;
        }

        addCompanyElementToSearchResults(companyNumber, companyName, companyURL, companyPostcode, trainingSetType, activeKeywords) {
            const trainingSetObject = this;

            let newCompanyEntry, companyNumberElement, companyNameElement, actionsHolder, actionCompanyLink, actionCompanyPostcode;

            newCompanyEntry = coreFunctions.createElementHelper("div", { class: `trainingSetListItem${(trainingSetType == "exclude") ? " orange" : ""} flex-row-holder`, "data-companynumber": companyNumber, "data-companyname": companyName, "data-companyurl": companyURL, "data-trainingsettype": trainingSetType, "data-companypostcode": companyPostcode, "data-keywords": JSON.stringify(activeKeywords) });

            companyNumberElement = newCompanyEntry.appendChild(coreFunctions.createElementHelper("div", { class: "trainingSetCompanyNumber" })); // Company number
            companyNumberElement.appendChild(coreFunctions.createElementHelper("a", { innerHTML: companyNumber, href: `https://find-and-update.company-information.service.gov.uk/company/${companyNumber}`, target: "_blank" })); // Companies house link

            companyNameElement = newCompanyEntry.appendChild(coreFunctions.createElementHelper("div", { class: "trainingSetCompanyName flex-grow", title: companyName })); // Company name
            companyNameElement.appendChild(coreFunctions.createElementHelper("a", { innerHTML: companyName, href: `${urlPath}/companypage?company_id=${companyNumber}`, target: "_blank" })); // Link to Data City companies page

            actionsHolder = newCompanyEntry.appendChild(coreFunctions.createElementHelper("div", { class: "companyActionsHolder" }));

            if (companyURL) {
                actionCompanyLink = actionsHolder.appendChild(coreFunctions.createElementHelper("div", { class: "companyAction" }));
                actionCompanyLink.appendChild(coreFunctions.createElementHelper("a", { class: 'actionControl company-url', target: "_blank", href: companyURL, innerHTML: "<span>URL</span>" })); // Link to company webpage

                if (companyPostcode) {
                    actionCompanyPostcode = actionsHolder.appendChild(coreFunctions.createElementHelper("div", { class: "companyAction companyActionPostcode" }));
                    actionCompanyPostcode.appendChild(coreFunctions.createElementHelper("a", { class: "actionControl company-location", target: "_blank", href: `https://maps.google.com/?q=${companyPostcode}`, innerHTML: `<span>${companyPostcode}` })); // Company location link
                }

                newCompanyEntry.appendChild(coreFunctions.createElementHelper("div", {class: "training-set-control-holder"})).appendChild(this.createTrainingSetAddControlOrDescription(companyNumber, companyName, companyURL, companyPostcode, trainingSetType, activeKeywords));

            } else {
                actionsHolder.appendChild(coreFunctions.createElementHelper("div", { class: "companyAction noUrlWarning", innerHTML: `<img src='${urlPath}/images/warning-red.svg'><span>Requires URL</span>` })); // Warning about no URL

                newCompanyEntry.appendChild(coreFunctions.createElementHelper("div", {class: "training-set-control-holder"})).appendChild(coreFunctions.createElementHelper("button", { class: "reportMissingUrlButton", innerHTML: "Request<br>update", "data-companynumber": companyNumber, "data-companyname": companyName }, { click: function () { trainingSetObject.reportMismatchedUrlButtonClick(this) } }));
            }

            document.querySelector(".trainingSetListHolder").appendChild(newCompanyEntry);
            return this;
        }

        reportMismatchedUrlButtonClick(element) {
            let companyName, companyNumber;
            companyName = element.dataset.companyname;
            companyNumber = element.dataset.companynumber;

            document.querySelector("#reportMismatchedUrlForm input[name='companyNumber']").value = companyNumber;
            document.querySelector("#reportMismatchedUrlForm input[name='companyName']").value = companyName;
            document.querySelector("#reportMismatchedUrlForm input[name='suggestedURL']").value = null;
            document.getElementById("reportMismatchedUrlCompanyName").querySelector("span").innerHTML = companyName;
            document.getElementById("reportMismatchedUrlButton").focus();

            coreFunctions.showOverlay("reportmismatchedurl");
        }

        reportMissingUrl(form) {
            let input, method, url;
            const trainingSetObject = this;

            document.getElementById("reportMismatchedUrlButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/company/company_actions.php?action=reporturl&company_number=${form.elements.companyNumber.value}`;

            const reportMissingUrlSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                trainingSetObject.reportMissingUrlLoad(response);
            }

            const reportMissingUrlError = function () {
                const response = {
                    status: "error",
                    title: "Submission error",
                    message: "Sorry, we could not submit your request at this time."
                }
                trainingSetObject.reportMissingUrlLoad(response);
            }

            coreFunctions.xhrHelper(method, url, reportMissingUrlSuccess, reportMissingUrlError, input);
        }

        reportMissingUrlLoad(response) {
            let reportMismatchedUrlControl;

            document.getElementById("reportMismatchedUrlButton").disabled = false;

            if (response && response.status == "success") {
                if (reportMismatchedUrlControl = document.querySelector(`.reportMissingUrlButton[data-companynumber='${response.companyNumber}']`)) {
                    reportMismatchedUrlControl.classList.add("reported");
                }
            }
            coreFunctions.showStatusMessage(response.title, response.message);
            coreFunctions.hideOverlay(document.getElementById("reportMismatchedUrlButton"));
        }


        // Refresh all controls for any company in search results
        refreshTrainingSetAddControlOrDescriptions() {
            document.querySelectorAll(".trainingSetListItem").forEach(element => this.refreshTrainingSetAddControlOrDescription(element.dataset.companynumber, element.dataset.companyname, element.dataset.companyurl, element.dataset.companypostcode, element.dataset.trainingsettype, element.dataset.keywords));
            return this;
        }

        // Refresh controls for a single company in search results
        refreshTrainingSetAddControlOrDescription(companyNumber, companyName, companyURL, companyPostcode, trainingSetType, keywords) {
            let companyActionsHolder;
            if (companyActionsHolder = document.querySelector(`.trainingSetListItem[data-companynumber='${companyNumber}'] .training-set-control-holder`)) {
                companyActionsHolder.replaceChild(this.createTrainingSetAddControlOrDescription(companyNumber, companyName, companyURL, companyPostcode, trainingSetType), companyActionsHolder.lastElementChild, keywords);
            }
            return this;
        }

        createTrainingSetAddControlOrDescription(companyNumber, companyName, companyURL, companyPostcode, trainingSetType, activeKeywords) {
            let trainingSetControl;
            const trainingSetObject = this;

            // If not set keywords set to default value
            activeKeywords = activeKeywords ?? [];

            // If not set keywords set to default value
            activeKeywords = activeKeywords ?? [];

            if (this.checkCompanyTrainingSetIncluded(companyNumber)) {
                trainingSetControl = coreFunctions.createElementHelper("div", { class: "inactiveSearchAhead include green", innerHTML: `<span>Included</span>` });
            } else if (this.checkCompanyTrainingSetExcluded(companyNumber)) {
                trainingSetControl = coreFunctions.createElementHelper("div", { class: "inactiveSearchAhead exclude orange", innerHTML: `<span>Excluded</span>` });
            } else if (this.companyUrlExistsInTrainingSet(companyURL)) {
                trainingSetControl = coreFunctions.createElementHelper("div", { class: "inactiveSearchAhead include green", innerHTML: `<span>Website included</span>` }); // Company URL is already active in the training set
            } else {
                trainingSetControl = coreFunctions.createElementHelper("button", { innerHTML: `<span style='vertical-align: middle'>Add</span>`, "data-companynumber": companyNumber, "data-companyname": companyName, "data-companyurl": companyURL, "data-trainingsettype": trainingSetType, "data-companypostcode": companyPostcode, "data-keywords": JSON.stringify(activeKeywords) }, { click: function () { trainingSetObject.addCompanyToTrainingSetButtonClick(this); } });
            }
            return trainingSetControl;
        }

        addCompanyToTrainingSetButtonClick(element) {
            const dataset = element.dataset;
            this.newTrainingSetCompany(dataset.trainingsettype, dataset.companynumber, dataset.companyname, dataset.companyurl, dataset.companypostcode, dataset.keywords).addTrainingSetElementToList();
            this.updateTrainingSetBuildProgress().refreshTrainingSetAddControlOrDescriptions();
            mlList.storeCurrentListDetails();
            return this;
        }

        newTrainingSetCompany(trainingSetType, companyNumber, companyName, companyURL, companyPostcode, keywords) {
            const trainingSetCompany = new TrainingSetCompany(trainingSetType, companyNumber, companyName, companyURL, companyPostcode, JSON.parse(keywords), true);
            this[trainingSetType].push(trainingSetCompany);
            return trainingSetCompany;
        }

        updateTrainingSetBuildProgress() {
            let totalCompaniesInTrainingSet = this.getTotalCompaniesInTrainingSet();

            document.getElementById("trainingSetCompaniesBox").dataset.count = totalCompaniesInTrainingSet;
            // document.querySelector(".introWrapper").classList.add("hidden");
            document.querySelector(".trainingSetProgressWrapper").classList.remove("hidden");
            document.getElementById("trainingSetCompaniesTally").innerHTML = `${totalCompaniesInTrainingSet}${(totalCompaniesInTrainingSet == 1) ? " company" : " companies"}`;

            // Only need to update progress if less than 10 companies
            if (totalCompaniesInTrainingSet <= 10) {
                Array.from(document.querySelectorAll(".trainingSetProgress")).forEach((element, index) => {
                    if (index < totalCompaniesInTrainingSet) {
                        element.classList.add("selected");
                    } else {
                        element.classList.remove("selected");
                    }
                })

                document.querySelector(".trainingSetProgressRating:not(.hidden)").classList.add("hidden");
                if (totalCompaniesInTrainingSet < this.minimumCompaniesInTrainingSet) {
                    document.querySelector(".trainingSetProgressRating.incomplete").classList.remove("hidden");
                    document.getElementById("incompleteRequiredCompanies").innerHTML = this.minimumCompaniesInTrainingSet - totalCompaniesInTrainingSet;
                    document.getElementById("trainingSetProgessDescription").innerHTML = `A minimum of ${this.minimumCompaniesInTrainingSet} companies are required.`;
                    document.getElementById("nextStepButton").classList.add("hidden");
                } else if (totalCompaniesInTrainingSet == this.minimumCompaniesInTrainingSet) {
                    document.querySelector(".trainingSetProgressRating.good").classList.remove("hidden");
                    document.getElementById("nextStepButton").classList.remove("hidden");
                    document.getElementById("trainingSetProgessDescription").innerHTML = "You're done! Adding more companies will improve your results.";
                } else if (totalCompaniesInTrainingSet <= 6) {
                    document.querySelector(".trainingSetProgressRating.good").classList.remove("hidden");
                    document.getElementById("nextStepButton").classList.remove("hidden");
                    document.getElementById("trainingSetProgessDescription").innerHTML = "Adding more companies will improve your results.";
                } else {
                    document.querySelector(".trainingSetProgressRating.excellent").classList.remove("hidden");
                    document.getElementById("nextStepButton").classList.remove("hidden");
                    document.getElementById("trainingSetProgessDescription").innerHTML = "&nbsp;";
                }

            }
            return this;
        }

        getTotalCompaniesInTrainingSet() {
            return this.include.length + this.exclude.length;
        }

        showSearchSpinner() {
            let spinner = document.getElementById("spinner");
            spinner.style.display = "block";
            setTimeout(function () {
                spinner.style.opacity = "1";
            }, 100);
            setTimeout(function () {
                spinner.classList.add("spinnerVisible");
            }, 500);
        }

        hideSearchSpinner() {
            let spinner, hideTimeout;

            spinner = document.getElementById("spinner");

            if (spinner.classList.contains("spinnerVisible") == true) {
                hideTimeout = 200;
            } else {
                hideTimeout = 500;
            }
            setTimeout(function () {
                spinner.style.opacity = "0";
                setTimeout(function () {
                    spinner.style.display = "none";
                    spinner.classList.remove("spinnerVisible");
                }, 400);
            }, hideTimeout);
        }

        checkCompanyTrainingSetIncluded(companyNumber) {
            return (this.include.find(company => company.companyNumber == companyNumber) != undefined);
        }

        checkCompanyTrainingSetExcluded(companyNumber) {
            return (this.exclude.find(company => company.companyNumber == companyNumber) != undefined);
        }

        removeCompanyFromTrainingSet(companyNumber, trainingSetType) {
            let companyIndex = this[trainingSetType].findIndex(key => key.companyNumber === companyNumber);
            this[trainingSetType].splice(companyIndex, 1);
            return this;
        }

        addAllCompaniesToTrainingSet(trainingSetType) {
            const trainingSetObject = this;
            let addCompanyToTrainingSetControls = document.querySelectorAll(`.trainingSetListHolder[data-trainingsettype='${trainingSetType}'] .trainingSetListItem button:not(.reportMissingUrlButton)`);
            addCompanyToTrainingSetControls.forEach(control => trainingSetObject.addCompanyToTrainingSetButtonClick(control));
        }

        toggleCompanyInputVisibility() {
            if (document.getElementById("companyInputMain").classList.contains("companyInputHidden")) {
                this.showCompanyInput();
            } else {
                this.hideCompanyInput();
            }

            return this;
        }

        showCompanyInput() {
            if (!document.getElementById("lockCompanyInputControls").checked) {
                document.getElementById("companyInputMain").classList.remove("companyInputHidden");
            }
            return this;
        }

        hideCompanyInput() {
            if (!document.getElementById("lockCompanyInputControls").checked) {
                document.getElementById("companyInputMain").classList.add("companyInputHidden");
            }
            return this;
        }

        batchSearchInitiate(form) {
            const batchSearchInput = form.querySelector("[name='batchsearchinput']").value;
            const trainingSetType = form.dataset.trainingsettype;

            if (batchSearchInput.length > 0) {
                document.getElementById("batchSearchButton").disabled = true;
                const batchSearchCompanyNumbers = batchSearchInput.trim().split(" ");

                fetch(`../api/ml_list/ml_list_actions.php?action=batch_training_set_search`, {
                    method: 'POST',
                    body: JSON.stringify(batchSearchCompanyNumbers),
                    headers: {
                      'Content-type': 'application/json; charset=UTF-8',
                    }
                })
                .then(response => response.json())
                .then(data => {
                    document.getElementById("batchSearchButton").disabled = false;
                    this.processBatchSearchResults(data, trainingSetType);
                });
            }
        }

        processBatchSearchResults(results, trainingSetType) {
            let companiesAddedToTrainingSet = 0;
            results.forEach(result => {
                let companyURL = coreFunctions.formatUrl(result.CompanyURL);
                // Limit to companies where URL is not already in a training set
                if (!this.companyUrlExistsInTrainingSet(companyURL)) {
                    this.newTrainingSetCompany(trainingSetType, result.CompanyNumber, result.CompanyName, companyURL, result.CompanyPostcode, "[]").addTrainingSetElementToList();
                    this.updateTrainingSetBuildProgress();
                    companiesAddedToTrainingSet++;
                }
            });
            this.batchSearchCompleted(companiesAddedToTrainingSet, trainingSetType).refreshTrainingSetAddControlOrDescriptions();
        }

        batchSearchCompleted(batchSearchMatches, trainingSetType) {
            document.getElementById("batchSearchButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("batchSearchButton"));
            coreFunctions.showStatusMessage("Processing complete", `${batchSearchMatches} new ${((batchSearchMatches == 1) ? "company" : "companies")} have been added to your training set.`);
            mlList.storeCurrentListDetails();
            return this;
        }

        companyExistsInTrainingSet(companyNumber) {
            if (this.include.find(company => company.companyNumber == companyNumber)) {
                return true;
            } else if (this.exclude.find(company => company.companyNumber == companyNumber)) {
                return true;
            } else {
                return false;
            }
        }

        companiesInstantSearch(form) {
            this.showSearchSpinner();
            const input = new FormData(form);
            const method = "POST";
            const url = `../api/instant_search/instant_search_actions.php?action=training_set_search`;
            const options = {responseType: "json"};
            const success = (response) => this.companiesInstantSearchOnLoad(response);
            const error = () => this.companiesInstantSearchOnLoad();
            coreFunctions.xhrHelper(method, url, success, error, input, options, form);
        }

        companiesInstantSearchOnLoad(response = {}) {
            this.hideSearchSpinner();
            if (response.results) {
                coreFunctions.checkForDebugMessages(response);
                this.resetSearchResultsElement().processSearchResults(response.results, "include", []);
                document.getElementById("companyResultsContainer").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"}); // Scroll to results
            } else {
                coreFunctions.showStatusMessage("Company search failed", "Sorry an unexpected error occurred. Please try again.");
            }
            return this;
        }
    }

    class TrainingSetCompany {
        constructor(trainingSetType, companyNumber, companyName, companyURL, companyPostcode, keywords, availableInDatabase) {
            this.trainingSetType = trainingSetType;
            this.companyNumber = companyNumber;
            this.companyName = companyName;
            this.companyURL = companyURL;
            this.companyPostcode = companyPostcode;
            this.keywords = keywords;
            this.availableInDatabase = availableInDatabase;
        }

        addTrainingSetElementToList() {
            const trainingSetCompanyObject = this;
            let trainingSetListElement, trainingSetListCompanyNumber;

            trainingSetListElement = coreFunctions.createElementHelper("div", { class: `flex-row-holder trainingSetCompany${(this.availableInDatabase) ? "" : " notAvailableInDatabase unavailable"}${(this.trainingSetType == "include") ? " green" : " orange"}`, "data-companynumber": this.companyNumber, "data-companyname": this.companyName, "data-companyurl": this.companyURL, "data-trainingsettype": this.trainingSetType }); // Holder for list element

            trainingSetListCompanyNumber = trainingSetListElement.appendChild(coreFunctions.createElementHelper("div", { class: "trainingSetCompanyNumber" })); // Company number
            trainingSetListCompanyNumber.appendChild(coreFunctions.createElementHelper("a", { innerHTML: this.companyNumber, href: `https://find-and-update.company-information.service.gov.uk/company/${this.companyNumber}`, target: "_blank" })); // Link to companies house

            trainingSetListElement.appendChild(coreFunctions.createElementHelper("div", {class: "flex-grow"})).appendChild(coreFunctions.createElementHelper("a", { class: "trainingSetCompanyName", innerHTML: `${this.companyName}${(this.availableInDatabase) ? "" : " (UNAVAILABLE)"}`, href: this.companyURL, target: "_blank" }));

            trainingSetListElement.appendChild(coreFunctions.createElementHelper("button", { class: "actionControl delete_company", innerHTML: "&nbsp;" }, { click: function () { trainingSetCompanyObject.removeCompanyFromTrainingSetButtonClick() } })); // Delete company from training set

            document.querySelector(`.trainingSetCompaniesList[data-trainingsettype='${this.trainingSetType}']`).appendChild(trainingSetListElement);

            return this;
        }

        removeCompanyFromTrainingSetButtonClick() {
            this.removeCompanyElementFromTrainingSetList();
        }

        removeCompanyElementFromTrainingSetList() {
            let holder = document.querySelector(`.trainingSetCompaniesList[data-trainingsettype='${this.trainingSetType}']`);
            holder.removeChild(holder.querySelector(`.trainingSetCompany[data-companynumber='${this.companyNumber}']`));
            mlList.trainingSet.removeCompanyFromTrainingSet(this.companyNumber, this.trainingSetType).updateTrainingSetBuildProgress().refreshTrainingSetAddControlOrDescriptions();
            mlList.storeCurrentListDetails();
            return this;
        }
    }

    class ListKeywords {
        constructor() {
            this.containsKeywords = [];
            this.doesNotContainKeywords = [];
            this.containsKeywordsTomSelect;
            this.doesNotContainKeywordsTomSelect;
        }

        configureKeywordInputElements() {
            this.containsKeywordsTomSelect = new TomSelect("#containKeywordsInput", this.getKeywordInputElementOptions("containsKeywords"));
            this.doesNotContainKeywordsTomSelect = new TomSelect("#doesNotContainKeywordsInput", this.getKeywordInputElementOptions("doesNotContainKeywords"));
        }

        getKeywordInputElementOptions(type) {
            const self = this;
            const options = {
                plugins: ['no_backspace_delete','remove_button'],
                persist: false,
                duplicates: false,
                createOnBlur: true,
                create: true,
                onItemAdd: (value, item) => self.keywordItemAdded(value, item),
                onItemRemove: (value, item) => self.keywordItemRemoved(value, item),
                render: {
                    no_results: (data,escape) => null,
                    item: function(data, escape) {
                        return `<div data-type="${type}">${data.text}</div>`;
                    },
                }
            }
            return options;
        }

        keywordItemAdded(value, item) {
            const keywordType = item.dataset.type;
            if (value.length) {
                const keyword = new ListKeyword(value.trim(), keywordType);
                this[keywordType].push(keyword);
            }
            this.companySearchByKeywordOnInput();
            return this;
        }

        keywordItemRemoved(value, item) {
            const keywordType = item.dataset.type;
            if (value.length) {
                this[keywordType].splice(this[keywordType].findIndex(element => element.keyword == value), 1);
            }
            this.companySearchByKeywordOnInput();
            return this;
        }


        addNewKeyword(formElement) {
            let inputElement, newKeyword;
            inputElement = formElement.querySelector("input");
            if (inputElement.value.length > 0) {
                newKeyword = new ListKeyword(inputElement.value.trim(), inputElement.dataset.keywordtype).newKeywordElement();
                if (newKeyword.type == "include") {
                    this.containsKeywords.push(newKeyword);
                } else {
                    this.doesNotContainKeywords.push(newKeyword);
                }
                inputElement.value = null;
                this.companySearchByKeywordOnInput();
            }
            return this;
        }

        removeKeyword(keyword, type) {
            if (type == "include") {
                this.containsKeywords.splice(this.containsKeywords.findIndex(element => element.keyword == keyword), 1);
            } else {
                this.doesNotContainKeywords.splice(this.doesNotContainKeywords.findIndex(element => element.keyword == keyword), 1);
            }
            return this;
        }

        getActiveKeywords() {
            return {
                include: this.containsKeywords.map(keywordObj => keywordObj.keyword),
                exclude: this.doesNotContainKeywords.map(keywordObj => keywordObj.keyword),
                trainingSetType: "include" // When creating a list we only ever include companies in the training set
            };
        }

        keywordSearchValid() {
            return (this.containsKeywords.length > 0);
        }

        companySearchByKeywords(element) {
            let input, method, url;
            const keywordsObject = this;

            if (this.keywordSearchValid()) {
                mlList.trainingSet.showSearchSpinner();
                element.disabled = true;
                document.getElementById("companyInputMain").classList.add("searchInProgress");

                input = this.getActiveKeywords();
                method = "POST";
                url = `../api/ml_list/ml_list_actions.php?action=company_keyword_search`;

                const companySearchByKeywordsSuccess = function (responseText) {
                    const response = JSON.parse(responseText);
                    keywordsObject.companySearchByKeywordsLoad(response, element);
                }

                const companySearchByKeywordsError = function () {
                    const response = {
                        status: "error",
                        title: "Search error",
                        message: "Sorry, search could not be processed."
                    }
                    keywordsObject.companySearchByKeywordsLoad(response, element);
                }

                coreFunctions.xhrHelper(method, url, companySearchByKeywordsSuccess, companySearchByKeywordsError, JSON.stringify(input));
            } else {
                this.keywordSearchInputError();
            }
        }

        keywordSearchInputError() {
            var inputErrors = document.querySelectorAll(".findButton_error");
            for (var i = 0; i < inputErrors.length; i++) {
                inputErrors[i].classList.remove("hidden");
            }
        }

        companySearchByKeywordOnInput() {
            let inputErrors = document.querySelectorAll(".findButton_error:not(.hidden)");
            for (var i = 0; i < inputErrors.length; i++) {
                inputErrors[i].classList.add("hidden");
            }
        }

        companySearchByKeywordsLoad(response, element) {
            let activeKeywords;
            element.disabled = false;
            document.getElementById("companyInputMain").classList.remove("searchInProgress");
            mlList.trainingSet.hideSearchSpinner();
            if (response.status == "success") {
                coreFunctions.checkForDebugMessages(response);
                activeKeywords = this.getActiveKeywords();
                mlList.trainingSet.resetSearchResultsElement().processSearchResults(response.results, response.trainingSetType, activeKeywords.include.concat(activeKeywords.exclude));
            } else {
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }
    }

    class ListKeyword {
        constructor(keyword, type) {
            this.keyword = keyword;
            this.type = type;
        }

        newKeywordElement() {
            let holder, li, liButton, liSpan;
            const keyword = this;
            holder = document.querySelector(`.keywordsHolder[data-keywordtype='${this.type}']`);
            holder.classList.remove("hidden");

            li = coreFunctions.createElementHelper("li", { keyword: this.keyword, keywordtype: this.type });
            liButton = li.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "&nbsp;", type: "button" }, { click: function (e) { keyword.deleteKeywordElement() } }));
            liSpan = li.appendChild(coreFunctions.createElementHelper("span", { innerHTML: this.keyword }));
            holder.appendChild(li);

            return this;
        }

        deleteKeywordElement() {
            let li, ul;
            li = document.querySelector(`.keywordsHolder[data-keywordtype='${this.type}'] li[keyword='${this.keyword}']`);
            ul = li.closest("ul");
            ul.removeChild(li);
            if (ul.children.length == 0) {
                ul.classList.add("hidden");
            }
            mlList.listKeywords.removeKeyword(this.keyword, this.type);
            return this;
        }
    }

    const mlList = new ML_List(getFolderId());

    // Public functions
    return {
        pageBodyLoad: pageBodyLoad,
        mlList: mlList
    }
}();
